import React, { useMemo } from 'react';
import classNames from 'classnames';

import Trans from 'components/Common/Translation/Trans';
import { formatDiscountPercentage } from 'services/formatter';

import styles from './CartProductDiscount.module.scss';

export default function CartProductDiscount({
  className,
  discountPercentage,
}: {
  className: string;
  discountPercentage: number;
}): JSX.Element {
  const discountPercentageFormatting = useMemo(
    () => formatDiscountPercentage(discountPercentage),
    [discountPercentage]
  );

  return (
    <div className={classNames(styles.container, className)}>
      <Trans
        i18nKey="LABEL_DISCOUNT_FORMAT"
        values={{ amount: discountPercentageFormatting }}
      />
    </div>
  );
}
